







































import { Component, Vue, Prop } from 'vue-property-decorator'
import moment from 'moment'

@Component({})
export default class Footer extends Vue {

scrollTop () {
  this.$vuetify.goTo(0)
}

}
